import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { gettime2 } from '../../utils/time'
import { useTranslation } from 'react-i18next'
import { getmyevents, getsystemlis, cancle } from '../../utils/api'
import { Dialog } from '@nutui/nutui-react';
import { divide } from 'lodash';

const ConflictEvents: React.FC = () => {
  const parmas = useParams()
  // const data: any = parmas.item
  // let data1 = JSON.parse(data)
  // let [data2, getdata] = useState(data1.childEvents)
  // console.log(data1.childEvents, 55);

  // let [id, setid] = useState(parmas.item) as any
  const [search, setsearch] = useSearchParams()
  const [id, seteventId] = useState(search.get("eventId"));
  const [times, settime] = useState(search.get("time"));
  let [id2, setid2] = useState('') as any
  let [ft, setft] = useState(false) as any

  let [data2, getdata] = useState([]) as any
  const initFormRef = useRef(data2) as any;

  useEffect(() => {
    initFormRef.current = data2;
  }, [data2])

  const [sdmUserId, setsdmUserId] = useState('');
  let sdmUserIdref = useRef('')
  useEffect(() => {
    sdmUserIdref.current = sdmUserId
  }, [sdmUserId])

  const { t } = useTranslation()
  const goBackPage = () => {
    window.history.back()
  }

  const [typeData, gettypeData] = useState([]);

  const systemlis = async () => {
    await getsystemlis('sys_event_status').then((res) => {
      gettypeData(res.data)
      getDate(res.data)
    }
    );
  }

  const getDate = (data: any, time?: any) => {
    getmyevents({
      sdmId: sdmUserIdref.current,
      date: times
    }).then((res) => {
      if (data)




        data.forEach((item: any) => {
          res.rows.forEach((item2: any) => {
            if (item2.eventType == item.dictValue) {
              item2.status = item.dictLabel
            }
            item2.childEvents.forEach((item3: any) => {
              if (item3.eventType == item.dictValue) {
                item3.status = item.dictLabel
              }

            })
          })
        });

      let color = ['4AABEC', 'E21CAE', 'FD8B86', 'FD8D10', 'FFC932', '6AEC87', '76A534', '9F6FFF', 'E97190', '7483C4']
      res.rows.forEach((item: any) => {

        item.eventcolors = color[Number(item.eventType) - 1]
        item.childEvents.forEach((item3: any) => {
          item3.eventcolors = color[Number(item3.eventType) - 1]
        })

        item.time = gettime2(item.eventStartTime, item.eventEndTime)
        item.childEvents.forEach((item2: any) => {
          item2.time = gettime2(item2.eventStartTime, item2.eventEndTime)
        })

        if (item.childEvents.length > 0) {
          let a: any = {
            eventCountry: item.eventCountry,
            eventEndTime: item.eventEndTime,
            eventId: item.eventId,
            eventLocation: item.eventLocation,
            eventName: item.eventName,
            eventType: item.eventType,
            eventStartTime: item.eventStartTime,
            latitude: item.latitude,
            longitude: item.longitude,
            time: item.time,
            status: item.status,
            eventcolors: item.eventcolors
          }
          item.childEvents.push(a)
        }

      });

      let childEventsdata: any = []
      res.rows.forEach((item: any) => {

        if (item.eventId == id) {
          childEventsdata = item.childEvents

        }
      })

      initFormRef.current = childEventsdata
    

      getdata(initFormRef.current)
      setft(true)
    }
    );
  }




  const cancel = async (id: any, index: number) => {

    Dialog.alert({
      content: t('Whethertocancel'),
      confirmText: 'confirm',
      cancelText: 'cancel',
      onConfirm: (e) => {
        cancle({
          sdmUserId: sdmUserIdref.current,
          eventId: id
        }).then((res) => {
          if (res.code == 200) {
            setft(false)
            systemlis()
            // let da = data2
            // da.splice(index, 1);
            // getdata([...da])


            // console.log(data2)
          }
        });
      }
    });

  }


  useEffect(() => {
    // console.log(data2)
    window.scrollTo(0, 0);
    let data3: any = []
    data3 = localStorage.getItem('userinformation')
    data3 = JSON.parse(data3)
    sdmUserIdref.current = data3.userId
    systemlis()
  }, []);

  return <div style={{ backgroundColor: '#202225', paddingBottom: '20px' }}>
    <div style={{ backgroundColor: '#1B1D22', }}>
      <div style={{
        width: '100%', height: '100%', zIndex: 1001, borderTopLeftRadius: '20px'
        , borderTopRightRadius: '10px', backgroundColor: '#202225', paddingBottom: 20,
        display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <img src={require("../../static/img/xljt.png")} style={{ width: '24px', height: '24px', marginRight: '10px', marginLeft: '20px', }} onClick={() => goBackPage()}></img>
        <div style={{ width: '100%', height: '64px', paddingRight: '44px' }}>
          <div style={{ lineHeight: '64px', fontSize: '15px', fontWeight: 500, color: '#BABBBE', textAlign: 'center', width: '100%', }}>{t('Conflictevents')}</div>
        </div>

      </div>
    </div>
    <div>
      {
        ft && <div>
          {
            initFormRef.current.length > 0 ? <div>
              {
                initFormRef.current.map((item: any, index: any) =>
                  <div key={index} style={{
                    backgroundColor: '#46474F', borderLeft: '10px solid',
                    borderLeftColor: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'),
                    color: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'), borderRadius: '10px', padding: '5px',
                    marginLeft: '20px', marginRight: '20px', marginBottom: '10px', height: '95px'
                  }}>
                    {/* <div>{item.eventEndTime}{index}</div> */}
                    <Link to={`/eventdetails?eventId=${item.eventId}&country=${item.country}`
                    }
                      style={{ color: '#FFF', textDecorationLine: 'none' }}

                    >
                      <div style={{ margin: 10, display: 'flex', flexDirection: 'row' }}>
                        <div style={{ fontSize: '12px', lineHeight: '14px', height: '14px', fontWeight: 500, marginRight: '10px', color: '#ffF' }}>
                          {item.time}
                        </div>
                        <div style={{ color: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'), fontSize: '12px', lineHeight: '14px', height: '14px', fontWeight: 500 }}>{item.status}</div>
                      </div>

                      <div style={{
                        fontSize: '16px', lineHeight: '19px', height: '19px', fontWeight: 600, color: '#ffF',
                        marginLeft: '10px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '180px'
                      }}>
                        {item.eventName}
                      </div>
                    </Link>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                      {/* <Link to={`/plat3?data=${JSON.stringify(data2)}&item=${JSON.stringify(item)}`} */}
                      <Link to={`/plat3?name=${item.eventName}&latitude=${item.latitude}&longitude=${item.longitude}&id=${id}`}
                        style={{ color: '#FFF', textDecorationLine: 'none' }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row', height: '14px', margin: '10px' }}>
                          <img src={require("../../static/img/ph_map-pin.png")} style={{ width: '14px', height: '14px', justifyContent: 'center' }}></img>
                          <div style={{
                            fontSize: '12px', lineHeight: '14px', fontWeight: 500, color: '#BCAFFF', marginLeft: '10px', borderColor: '#BCAFFF', borderBottomWidth: 1, overflow: 'hidden'
                            , whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '180px'
                          }}>
                            {item.eventLocation}
                          </div>
                        </div>
                      </Link>
                      <div style={{
                        height: '24px', lineHeight: '14px', width: '57px', textAlign: 'center', color: '#fff', backgroundColor: '#FFFFFF4D', borderRadius: '12px'
                        , fontSize: '12px', padding: '5px', margin: '6px  9px 8px 9px', cursor: 'pointer'
                      }} onClick={() =>
                        cancel(item.eventId, index)}>
                        {t('Cancel')}
                      </div>
                    </div>

                  </div>
                )
              }
            </div> : <div style={{ color: '#fff', fontSize: '16px', textAlign: 'center' }}>
              {t('Therearecurrentlynoconflictingactivities')}
            </div>

          }
        </div>
      }
    </div>




  </div >
};


export default ConflictEvents;